module.exports = __webpack_public_path__ + "static/media/continued-flexibility-icon.edc2909f.svg";